module.exports = __webpack_public_path__ + "static/group-40-47aa6149a0a64040a4c294dac19ce8d2.svg";